import { $, SlickSlider } from "../../../../../../common/scripts/Libs";

class CSV2Testimonials {

    constructor() {

    }

    init() {
        $('.SingleCaseStudiesV2-testimonial__testimonials').slick({
            dots: true,
            arrows: false,
            speed: 300,
            slidesToShow: 1,
            centerPadding: '40px',
            mobileFirst: true,
            adaptiveHeight: true
        }, SlickSlider);
    }

}

export default CSV2Testimonials;